var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAthlete = function SvgAthlete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M14.246 0h23.745v.792h.006v6.333h-.005v.792h-4.75l.001 17.416H18.996v9.5H4.748V17.417H0V9.5h17.413V7.917h-3.167zm4.75 23.75h6.337V19h1.583v4.75h4.743v-9.5H23.75v2.375h-.007v.792h-4.748zM31.66 7.916v4.75H23.75v-2.374h-.006V9.5h-4.749V6.334H15.83v-4.75h20.585v4.75H31.66v1.582zM6.33 33.25h4.756V28.5h1.583v4.75h4.743v-9.5H6.33zm0-11.084h11.082v-6.332h4.755v-4.75H1.583v4.75h4.749z",
    clipRule: "evenodd"
  })));
};
export default SvgAthlete;